module.exports = __webpack_public_path__ + "static/media/calendar-icon.4e44ed6a.svg";